import React from "react";
import { Link } from "react-router-dom";

const Subnav = () => {
  return (
    <div className="sticky top-14 z-50 bg-gray-800 text-white shadow-md">
      <div className="max-w-screen-xl mx-auto px-4 py-2 flex justify-between items-center">
        <ul className="flex space-x-6">
          <li>
            <Link to="/inventory" className="text-lg hover:text-blue-400">
              Inventory
            </Link>
          </li>
          <li>
            <Link
              to="/inventory/inward-receipts"
              className="text-lg hover:text-blue-400"
            >
              Inward Receipts
            </Link>
          </li>
          <li>
            <Link
              to="/inventory/inward/new"
              className="text-lg hover:text-blue-400"
            >
              Add Inward
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Subnav;
